import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
type RegisterCredentialsDTO = {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    confirmPassword: string;
    phone: string;
    jobTitle?:string;
    birthDate?:string
    country: string;
};
type RegisterResponse = {
    data: object;
} & ApiError;
export const register = (
    data: RegisterCredentialsDTO
): Promise<RegisterResponse> => {
    return axios.post("/student/create", data);
};
